import angular from 'angular';
import { ISaldoInicialImportacaoArquivo, ISaldoInicialRow } from '../../models/saldo-inicial.model';

export class SaldoInicialImportarModalService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal: ng.ui.bootstrap.IModalService) {}

    open(entity: ISaldoInicialImportacaoArquivo, entities: ISaldoInicialRow[]) {
        return this.$uibModal.open({
            template: require('html-loader!./saldo-inicial-importar.modal.html'),
            controller: 'SaldoInicialImportarModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            windowClass: 'nsj-modal-lg-no-height',
            resolve: {
                entity: () => angular.copy(entity),
                entities: () => entities,
            },
        });
    }
}
